import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { vAPIURL, vGlobalDateNow } from '../../Global';
import axios from 'axios';
import toastr from 'toastr';
import DatePicker from 'react-datepicker';
import format from 'date-fns/format';
import startOfWeek from 'date-fns/startOfWeek';
import enGB from 'date-fns/locale/en-GB';

const PlayerCount = () => {
	const [ DataPlayerCount, SetDataPlayerCount ] = useState( [] );
	const [ Loading, setLoading ] = useState( false );
	const [ EndDate, SetEndDate ] = useState( new Date( vGlobalDateNow ) );
	const [ StartDate, SetStartDate ] = useState( new Date( startOfWeek( EndDate, { weekStartsOn: 1 } ) ) );

	const GetPlayerCount = async () => {
		setLoading( true );
		let vStatus = 1;
		let vMessage = [];

		try{
			const vURL = vAPIURL + "/Golf/Executive/PlayerCount";
			const vData = {
				Action: {
					Value: "Search",
				},
				Input: {
					StartDate: {
						Value: format( StartDate, 'dd-MMM-yyyy' ),
					},
					EndDate: {
						Value: format( EndDate, 'dd-MMM-yyyy' ),
					},
				},
			};
			const vConfig = {
				headers: {
					"Content-Type": "application/json",
					Authentication: `${localStorage.getItem("Authentication")}`,
				},
			};

			await axios
				.post(vURL, vData, vConfig)
				.then((vResponse) => {
					vStatus = vResponse.data.Status;

					for (var i = 0; i < vResponse.data.Message.length; i++) {
						vMessage.push(vResponse.data.Message[i]);
					}

					if (vStatus === 1) {
						SetDataPlayerCount(vResponse.data.Output.Result);
					}
				})
				.catch((vError) => {
					vStatus = 2;
					vMessage.push("Error");
				});
		}catch( vError ){
			vStatus = 2;
			vMessage.push( "Error" );
		}

		if( vMessage.length > 0 ){
			if( vStatus === 1 ){
				//toastr.success( vMessage.join( "</br>" ) );
			}
			else{
				toastr.error( vMessage.join( "</br>" ) );
			}
		}
		setLoading( false );
	};

	const BorderLinearProgressGreen = styled(LinearProgress)(({ theme }) => ({
		height: 10,
		borderRadius: 5,
		[`&.${linearProgressClasses.colorPrimary}`]: {
			backgroundColor: theme.palette.grey[200],
		},
		[`& .${linearProgressClasses.bar}`]: {
			borderRadius: 5,
			backgroundColor: '#00b050',
		},
	}));

	useEffect(() => {
		GetPlayerCount();
	}, []);

	return (
		<div className="card bg-gradient-light">
			<div className="card-header">
				<h3 className="card-title text-success font-weight-bold">
					FREQUENT PLAYERS
				</h3>
				<div className="card-tools">
					<ul className="nav nav-pills ml-auto">
						<li className="nav-item text-info font-weight-bold">
						</li>
					</ul>
				</div>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-sm-4 col-xl-2">
						<div className="form-group">
							<label>
								START DATE
							</label>
							<DatePicker
								dateFormat="dd-MMM-yyyy"
								selected={ StartDate }
								onChange={e => SetStartDate(e)}
								className="form-control"
								value={ StartDate }
								locale={ enGB }
							/>
						</div>
					</div>
					<div className="col-sm-4 col-xl-2">
						<div className="form-group">
							<label>
								END DATE
							</label>
							<DatePicker
								dateFormat="dd-MMM-yyyy"
								selected={ EndDate }
								onChange={ e => SetEndDate(e) }
								className="form-control"
								value={ EndDate }
								locale={ enGB }
							/>
						</div>
					</div>
					<div className="col-sm-4 col-xl-2">
						<button
							onClick={GetPlayerCount}
							type="submit"
							className="btn btn-primary float-right"
							style={{ marginTop:"31px" }}
						>
							<i className="fas fa-search"/>
							&nbsp;
							{Loading ?
									"Please wait..."
								:
									"Search"
							}
						</button>
					</div>
				</div>
				*Note Must Field In With Period Interval
			</div>
			{
				Loading
				?
				<div className="d-flex justify-content-center">
					<i className="fas fa-3x fa-sync-alt fa-spin"></i>
				</div>
				:
				<TableContainer component={Paper}>
					<Table aria-label="simple table">
						<TableHead sx={{ minHeight: 10 }} >
							{DataPlayerCount.map((Value, Index) => (
								<TableRow>
									<TableHead>
										<TableCell 
											sx={{ 
												maxWidth: 400
												, width: 400 
												, fontWeight: Index === DataPlayerCount.length - 1 ? 'bold' : 'normal'
											}}
										>
											{Value.Type}
										</TableCell>
										<TableCell 
											sx={{ 
												width: 340 
											}}
										>
											<BorderLinearProgressGreen variant="determinate" value={Value.Percentage}/>
										</TableCell>
										<TableCell 
											sx={{ 
												width: 100
												, fontWeight: Index === DataPlayerCount.length - 1 ? 'bold' : 'normal'
											}}
										>
											{Value.Percentage} %
										</TableCell>
										<TableCell 
											sx={{ 
												width: 300 
												, fontWeight: Index === DataPlayerCount.length - 1 ? 'bold' : 'normal'
											}} 
											align="right"
										>
											{Value.PlayerCount}
										</TableCell>
									</TableHead>
								</TableRow>
							))}
						</TableHead>
					</Table>
				</TableContainer>
			}
		</div>
	);
}

export default PlayerCount